import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawShareIcon from "./RawShareIcon.svg.jsx";

const ShareIcon = forwardRef((props, ref) => {
  return (
    <Icon ref={ref} SvgComponent={RawShareIcon} title="Share icon" {...props} />
  );
});

export default ShareIcon;
